import { getStockPriceHistory, getCorporateActions } from '@os/cloudquote';
import { filterRows, sortData, buildYears, adjustTimerange, setStart } from './utils';

export function filterStockData(stock, start, end) {
	stock.rows = filterRows(stock.rows || [], start, end);
	return stock;
}

export function corporateActions(symbol, type, start, end) {
	return getCorporateActions({
		symbols: [symbol],
		eventType: type
	})
		.then( (data) => filterStockData(data, start, end) );
}

export function getStockData({ symbol, start, end }) {
	return Promise.all([
		corporateActions(symbol, 'split', start, end),
		corporateActions(symbol, 'dividend', start, end)
	])
		.then( (data) => ({ splits: data[0], dividends: data[1] }) );
}

export function historicalData(data, start, end, interval) {
	data = sortData(data);
	data.years = buildYears(data);

	let { timerange, cacheData } = adjustTimerange(start, end, interval, data);

	return {
		cacheData,
		start: timerange.start,
		end: timerange.end
	};
}

export function getHistoricalData({ symbol, start, end, interval }) {
	if (interval === '1D') {
		start = setStart(start);
	}

	return getStockPriceHistory({
		symbol,
		to: end,
		from: start
	}).then( (data) => historicalData(data, start, end, interval) );
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/historical-data-panel/fetch-data.js